import { render, staticRenderFns } from "./PermissionSelector.vue?vue&type=template&id=237edefc"
import script from "./PermissionSelector.vue?vue&type=script&lang=js"
export * from "./PermissionSelector.vue?vue&type=script&lang=js"
import style0 from "./PermissionSelector.vue?vue&type=style&index=0&id=237edefc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports